import $S from 'theme/settings';
import {
  FETCH_CLICK_AND_COLLECT_ORDER_LIST_PENDING,
  FETCH_CLICK_AND_COLLECT_ORDER_LIST_REJECTED,
  FETCH_CLICK_AND_COLLECT_ORDER_LIST_FULFILLED,
  START_CLICK_AND_COLLECT_ORDER_LIST_AUTO_RELOAD,
  STOP_CLICK_AND_COLLECT_ORDER_LIST_AUTO_RELOAD,
  SET_ACTIVE_STATUS_FOR_CLICK_AND_COLLECT_ORDER_LIST,
  CLEAR_CLICK_AND_COLLECT_ORDER_LIST,
  FETCH_FILTER_ATTRS_FULFILLED,
  SELECTED_FILTER_ATTRS,
} from '../constants/clickAndCollectOrderList';

let selectedFilterAttrsLS = localStorage.getItem('selectedFilterAttrsLS') || '';
selectedFilterAttrsLS = selectedFilterAttrsLS.length
  ? JSON.parse(selectedFilterAttrsLS)
  : [];

const initialState = {
  pending: false,
  clickAndCollectOrders: [],
  autoReloadIntervalId: null,
  activeStatus: $S.clickAndCollectOrderListDefaultStatusesToShow[0].id,
  error: {},
  filterAttrs: [],
  selectedFilterAttrs: selectedFilterAttrsLS,
};

export const clickAndCollectOrderList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLICK_AND_COLLECT_ORDER_LIST_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_CLICK_AND_COLLECT_ORDER_LIST_REJECTED:
      return { ...state, pending: false, error: action.error.message };

    case FETCH_CLICK_AND_COLLECT_ORDER_LIST_FULFILLED:
      return {
        ...state,
        clickAndCollectOrders: action.data.results,
        pending: false,
        error: {},
      };

    case FETCH_FILTER_ATTRS_FULFILLED:
      return { ...state, filterAttrs: action.data };

    case SELECTED_FILTER_ATTRS:
      return { ...state, selectedFilterAttrs: action.data };

    case START_CLICK_AND_COLLECT_ORDER_LIST_AUTO_RELOAD:
      return {
        ...state,
        autoReloadIntervalId: action.data,
      };

    case STOP_CLICK_AND_COLLECT_ORDER_LIST_AUTO_RELOAD:
      return {
        ...state,
        autoReloadIntervalId: null,
      };

    case SET_ACTIVE_STATUS_FOR_CLICK_AND_COLLECT_ORDER_LIST:
      return {
        ...state,
        activeStatus: action.data,
      };

    case CLEAR_CLICK_AND_COLLECT_ORDER_LIST:
      const { activeStatus } = state;
      return {
        ...initialState,
        ...(activeStatus ? { activeStatus } : {}),
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/clickAndCollectOrderList.js